export const blockNameText = "Курсы";
export const allowedQuantityToAccess = 1;